/*
 * @Description:客户参数配置
 * @Autor: lwq
 * @Date: 2020-07-29 09:48:51
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-10-18 11:29:07
 * @FilePath: \mrc-base-server-view\src\service\api\costCenter.js
 */

import http from '../httpConfig'

const table = "mrbase_sys_client_param"

// 列表
export const custom_param_config_list = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/client-param/list-param/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 新增
export const add_custom_param_config = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/client-param/save-param/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}